/** Human labels for audit_log.entity_type. Unknown codes pass through unchanged. */

const AUDIT_ENTITY_LABELS: Record<string, string> = {
  activity: "Atividade",
  activity_interests: "Interesses da atividade",
  audience_rules: "Público e preços",
  refund_policies: "Política de reembolso",
  rsvp: "Inscrição",
  referral: "Indicação",
  referral_invite: "Convite",
  booking: "Reserva",
  event: "Evento (antigo)",
  event_interests: "Interesses do evento",
  event_reminder: "Lembrete de evento",
  experience: "Experiência (antiga)",
  experience_participant: "Participante de experiência",

  benefit: "Benefício",
  benefit_category: "Categoria de benefício",
  space: "Espaço (antigo)",
  space_type: "Tipo de espaço",
  space_amenity: "Comodidade",
  space_amenity_links: "Comodidades do espaço",
  space_type_tier_discount: "Desconto por plano (espaço)",
  venue: "Local",
  feed_post: "Post do News",
  feed_image: "Imagens do News",
  home_hero: "Destaques da home",
  interest: "Interesse",
  interest_category: "Categoria de interesse",
  interest_form: "Ficha de interesse",
  menu_category: "Categoria do cardápio",
  menu_item: "Item do cardápio",
  communication: "Comunicação",
  communication_template: "Modelo de comunicação",
  notification: "Notificação",
  staff_role: "Papel da equipe",
  staff_venue_coverage: "Cobertura de locais",
  tenant: "Clube",
  system_setting: "Configuração do sistema",

  subscription_discount_grant: "Concessão de plano",
  subscription_discount: "Desconto da assinatura",
  subscription: "Assinatura",
  subscription_invitation: "Convite de adesão",
  stripe_subscription: "Assinatura na Stripe",
  tier: "Plano",
  tier_billing_option: "Forma de pagamento",
  tier_billing_options: "Formas de pagamento",
  billing_snapshot: "Fatura do clube",
  dunning_config: "Régua de cobrança",
  dunning_step: "Passo da régua",
  renewal_reminder_rule: "Lembrete de renovação",
  invoice: "Fatura",
  payment: "Pagamento",
  payment_method: "Cartão",
  payment_account: "Conta Stripe",

  consent: "Consentimento",
  legal_document: "Documento legal",
  profile: "Perfil",
  profile_block: "Bloqueio",
  // Every `user` row is a retention record written after the account was deleted.
  user: "Conta excluída",
  crm_note: "Nota de CRM",
  member_interest: "Interesse do membro",
  affinity_score: "Afinidade",
};

const PT_BR = new Intl.Collator("pt-BR");

export function labelForAuditEntity(entityType: string): string {
  return AUDIT_ENTITY_LABELS[entityType] ?? entityType;
}

/** Filter options: value stays the raw code (the query is unchanged), sorted by pt-BR label. */
export function auditEntityOptions(codes: Iterable<string>): { value: string; label: string }[] {
  return Array.from(new Set(codes))
    .map((value) => ({ value, label: labelForAuditEntity(value) }))
    .sort((a, b) => PT_BR.compare(a.label, b.label));
}
